// libs bundle loaded, call the callback
window.queue.libsLoaded()
